import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import PaymentBadge from "@molecules/ObjectCard/Attributes/AttributeBadges/PaymentBadge/PaymentBadge"

import { BillPaymentBadgeProps } from "./BillPaymentBadge.types"

// Paid/unpaid indicator whose Paid tooltip shows what was paid and what vendor credit covered. Only rendered for
// bills in a billable lifecycle — Paid, Outstanding, or Overdue.
export default function BillPaymentBadge(props: BillPaymentBadgeProps) {
    const { status, isOverdue, total, amountPaid, amountCredited, amountDue, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    if (status === "Paid") {
        let tooltip = `Paid\n${formatCurrency(amountPaid)}`
        if (Number(total) === 0) {
            tooltip = "Paid\nZero-total bill"
        } else if (Number(amountCredited) > 0 && Number(amountPaid) > 0) {
            tooltip = `Paid\n${formatCurrency(amountPaid)} paid\n${formatCurrency(amountCredited)} credited`
        } else if (Number(amountCredited) > 0) {
            tooltip = `Paid with credit\n${formatCurrency(amountCredited)}`
        }
        return (
            <PaymentBadge level="full" size={size} tooltip={tooltip}>
                Paid
            </PaymentBadge>
        )
    }

    if (status === "Outstanding" || status === "Overdue") {
        return (
            <PaymentBadge
                level="none"
                isEscalated={isOverdue}
                size={size}
                tooltip={`Required\n${formatCurrency(amountDue)}`}
            >
                Unpaid
            </PaymentBadge>
        )
    }

    return null
}
